<template lang="html">

  <section class="banniere-horizontale-evenement">
    <div class="section">
        <div class="container">
            <a :href="lienAppMobile"><img src="../assets/img/img_telecharger_skanticket_mobile.jpg" class="img-fluid" alt=""></a>
        </div>
    </div>
  </section>

</template>

<script lang="js">
  export default  {
    name: 'banniere-horizontale-evenement',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {
      lienAppMobile: function(){
        let userAgent = navigator.userAgent || navigator.vendor || window.opera;

        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return "https://itunes.apple.com/us/app/skanticket/id1169570285?mt=8";
        }

        return "https://play.google.com/store/apps/details?id=ci.innovlabs.skanevent&hl=fr";
      }
    }
}
</script>
